import { useViewportType } from 'hooks/useViewportType'

import { SalaEsperaVideochamadaAnfitriaoDesktopLayout } from './componentes/SalaEsperaVideochamadaAnfitriaoDesktopLayout'
import { SalaEsperaVideochamadaAnfitriaoForm } from './componentes/SalaEsperaVideochamadaAnfitriaoForm'
import { SalaEsperaVideochamadaMobileLayout } from './componentes/SalaEsperaVideochamadaMobileLayout'

interface SalaEsperaVideochamadaAnfitriaoViewProps {
  nomeProfissional: string
  cboProfissional: string | null
  audioEnabled: boolean
  videoEnabled: boolean
  setAudioEnabled(value: boolean): void
  setVideoEnabled(value: boolean): void
  handleEntrarButtonClick(): void
  onVisualizarTermo(): void
}

export function SalaEsperaVideochamadaAnfitriaoView(props: Readonly<SalaEsperaVideochamadaAnfitriaoViewProps>) {
  const {
    nomeProfissional,
    cboProfissional,
    audioEnabled,
    videoEnabled,
    setAudioEnabled,
    setVideoEnabled,
    handleEntrarButtonClick,
    onVisualizarTermo,
  } = props

  // A escolha do layout monta árvores distintas, não só troca de CSS: renderizar as duas duplicaria a captura de câmera
  const { isMobile, isTablet } = useViewportType()
  const cameraProps = { audioEnabled, videoEnabled, setAudioEnabled, setVideoEnabled }

  return isMobile || isTablet ? (
    <SalaEsperaVideochamadaMobileLayout {...cameraProps}>
      <SalaEsperaVideochamadaAnfitriaoForm
        nomeProfissional={nomeProfissional}
        cboProfissional={cboProfissional}
        handleEntrarButtonClick={handleEntrarButtonClick}
        onVisualizarTermo={onVisualizarTermo}
        isMobile
      />
    </SalaEsperaVideochamadaMobileLayout>
  ) : (
    <SalaEsperaVideochamadaAnfitriaoDesktopLayout {...cameraProps}>
      <SalaEsperaVideochamadaAnfitriaoForm
        nomeProfissional={nomeProfissional}
        cboProfissional={cboProfissional}
        handleEntrarButtonClick={handleEntrarButtonClick}
        onVisualizarTermo={onVisualizarTermo}
      />
    </SalaEsperaVideochamadaAnfitriaoDesktopLayout>
  )
}
